export default {
  path: 'project',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'jxxfWbProjectIndex',
      component: () => import('@/features/jxxf/wb/project/projectList.vue'),
      meta: {
        navtabTitle: '维保项目管理',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'create',
      name: 'jxxfWbProjectCreate',
      component: () => import('@/features/jxxf/wb/project/projectDialog.vue'),
      meta: {
        navtabTitle: '新建维保项目',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'edit/:xmId',
      name: 'jxxfWbProjectEdit',
      component: () => import('@/features/jxxf/wb/project/projectDialog.vue'),
      meta: {
        navtabTitle: '编辑维保项目',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'detail/:xmId',
      name: 'jxxfWbProjectDetail',
      component: () => import('@/features/jxxf/wb/project/projectDetail.vue'),
      meta: {
        navtabTitle: '维保项目详情',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};
